module.exports = __webpack_public_path__ + "img/logo-disney.0ad601cb.svg";